import { render, staticRenderFns } from "./ConcernCompanyHotRanking.vue?vue&type=template&id=12ae91d0&scoped=true"
import script from "./ConcernCompanyHotRanking.vue?vue&type=script&lang=js"
export * from "./ConcernCompanyHotRanking.vue?vue&type=script&lang=js"
import style0 from "./ConcernCompanyHotRanking.vue?vue&type=style&index=0&id=12ae91d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae91d0",
  null
  
)

export default component.exports